import { endPoints } from "@/constants/apiSetting";
import httpClient from "@/common/service/HttpClient";
import SweetAlertService from "./SweetAlertService";
const PayrollTrialService = {
  getPayrollHdrList(obj) {
    return httpClient.post(endPoints.getPayrollTrialList, obj);
  },
  getPayrollTrialDtl(obj) {
    return httpClient.post(endPoints.getPayrollTrialDtl, obj);
  },
  savePayrollTrialItem(obj) {
    return httpClient.post(endPoints.savePayrollTrialItem, obj);
  },
  sendPayrollTrialItem(obj) {
    return httpClient.post(endPoints.sendPayrollTrialItem, obj);
  },
  printPayrollTrial(obj) {
    return httpClient.post(endPoints.printPayrollTrial, obj);
  },
  getPayrollTrialMsg(obj) {
    return httpClient.post(endPoints.getPayrollTrialMsg, obj);
  },
  exportPayrollTrial(obj) {
    return httpClient.post(endPoints.exportPayrollTrial, obj);
  },
  approvePayrollTrial(obj) {
    return httpClient.post(endPoints.approvePayrollTrial, obj);
  },
  rejectPayrollTrial(obj) {
    return httpClient.post(endPoints.approvePayrollTrial, obj);
  },
  exportAutopayFiles(obj) {
    return httpClient.post(endPoints.exportAutopayFiles, obj);
  },

  async deletePayrollTrial(txNum) {
    let obj = {
      txNum: txNum
    };
    const response = await httpClient.post(
      endPoints.deletePayrollTrialItem,
      obj
    );
    return response;
  }
};

export default PayrollTrialService;



// WEBPACK FOOTER //
// ./src/service/PayrollTrialService.js